import { FC, ReactNode } from 'react';

import { useTranslations } from 'hooks/useTranslations';
import Copyright from 'components/UI/Copyright';
import { isConstruction } from 'config';
import {
  PageContainer,
  ImageSection,
  ImageContent,
  ContentSection,
  ContentContainer,
  FlexContainer,
  ImageTitle,
  ImageDescription
} from './styled';

type Props = {
  children: ReactNode;
  alignTop?: boolean;
};

const PageImageWrapper: FC<Props> = ({ children, alignTop = false }) => {
  const t = useTranslations();
  return (
    <PageContainer>
      <ContentSection>
        <Copyright fullHeight>
          <FlexContainer $alignTop={alignTop}>
            <ContentContainer>{children}</ContentContainer>
          </FlexContainer>
        </Copyright>
      </ContentSection>
      <ImageSection>
        <ImageContent>
          <ImageTitle>
            {t(
              `start.${isConstruction ? 'construction' : 'husqvarna'}.image_title`
            )}
          </ImageTitle>
          <ImageDescription>
            {t(
              `start.${isConstruction ? 'construction' : 'husqvarna'}.image_description`
            )}
          </ImageDescription>
        </ImageContent>
      </ImageSection>
    </PageContainer>
  );
};

export default PageImageWrapper;
